import React from 'react'
import { BaseClientConfig } from 'common/client/BaseClientConfig'

export const ConfigurationContext = React.createContext<BaseClientConfig>(
    (undefined as any) as BaseClientConfig
)
